export default __webpack_public_path__ + "static/media/m.d40b5987.svg";